import { createUrl } from '@/utils';

const info = createUrl('info');

const taxAuthorityDepartments = info('tax-authority-departments');
const legalPersonActivities = info('legal-person-activities');

export const infoEndpoints = { taxAuthorityDepartments, legalPersonActivities };
